const punctuations = {
  ',' : '﹐',
  '.' : '。',
  ':' : '：',
  ';' : '；',
  '`' : '﹑',
  '?' : '？',
  '^' : '……',
  '!' : '！',
  '[' : '「',
  ']' : '」',
  '{' : '『',
  '}' : '』',
  '<' : '《 ',
  '>' : '》',
  '(' : '（',
  ')' : '）',
};
export {punctuations};
